// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UAVUI","question":"styles_question__2xsWU","description":"styles_description__169GT"};